"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TenantProfileImageUploadModule = /** @class */ (function () {
    function TenantProfileImageUploadModule() {
    }
    return TenantProfileImageUploadModule;
}());
exports.TenantProfileImageUploadModule = TenantProfileImageUploadModule;
